import { render, staticRenderFns } from "./ListPatient.vue?vue&type=template&id=59ae2f6c&scoped=true&"
import script from "./ListPatient.vue?vue&type=script&lang=ts&"
export * from "./ListPatient.vue?vue&type=script&lang=ts&"
import style0 from "./ListPatient.vue?vue&type=style&index=0&id=59ae2f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ae2f6c",
  null
  
)

export default component.exports